import React from "react"
import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group";


export default function FieldDate_GlistGroupModern(props:FieldGlistGroupProps) {

    const value = props.data.value

    return (
        <div className="ui5-group-by-text-2 text-color-white">
            {value && value !== 'null' && props.field.getDisplayValue(value)}
            {(!value || value === 'null') && props.field.noValueOptionLabel}
        </div>
    )

}
